import { api } from "../../axios";

export const state = {
  isDeliveryUnitsLoading: false,
  deliveryUnitsPerCampus: [],
};

export const mutations = {
  SET_DELIVERY_UNITS_LOADING(state, payload) {
    state.isDeliveryUnitsLoading = payload;
  },
  SET_DELIVERY_UNITS_PER_CAMPUS(state, payload) {
    state.deliveryUnitsPerCampus = payload;
  },
};

export const actions = {
  // DeliveryUnit
  GetDeliveryUnit() {
    return api.get("DeliveryUnit/GetAllDeliveryUnits");
  },
  GetDeliveryUnitByOffice(context, data) {
    return api.get(`DeliveryUnit/office/${data}`);
  },
  GetDeliveryUnitByCampus(context, data) {
    return api.get(`DeliveryUnit/Campus/${data}`);
  },
  GetSingleDeliveryUnit(context, data) {
    return api.get(`DeliveryUnit/${data}`);
  },
  UpdateDeliveryUnit(context, data) {
    return api.put(`DeliveryUnit/${data.id}`, data);
  },
  DeleteDeliveryUnit(context, data) {
    return api.delete(`DeliveryUnit/${data}`);
  },
  CreateDeliveryUnit(context, data) {
    return api.post(`DeliveryUnit/CreateDeliveryUnit`, data);
  },
  getDeliveryUnitByCampus(context, campusId) {
    return api.get(`DeliveryUnit/Campus/${campusId}`);
  },
  getDeliveryUnitByCluster(context, clusterId){
    return api.get(`DeliveryUnit/Cluster/${clusterId}`);
  }
};
